<script setup lang="ts">
import type { AgentShortsSectionSkeletonProps } from '.';

import { cn } from '~/utils';

import { Skeleton } from '~/components/ui/skeleton';

import {
	AGENT_SHORTS_CARD_CLASS,
	AGENT_SHORTS_GRID_CLASS,
	AGENT_SHORTS_SKELETON_COUNT
} from './grid';

defineProps<AgentShortsSectionSkeletonProps>();
</script>

<template>
	<section
		:class="
			cn(
				'w-full border-b border-white-dark-3 bg-white py-8 md:py-12',
				$props.class
			)
		"
		data-testid="agent-shorts-section-skeleton"
		aria-busy="true"
		aria-label="Carregando imóveis em Shorts"
	>
		<div
			class="mb-4 flex h-[30px] items-center gap-3 md:mb-6 md:h-12 md:gap-3.5"
			aria-hidden="true"
		>
			<Skeleton
				is-active
				variant="white"
				class="h-[29px] w-7 shrink-0 rounded-none motion-reduce:animate-none"
			/>
			<Skeleton
				is-active
				variant="white"
				class="h-[29px] w-[296px] max-w-[calc(100%-42px)] rounded-none motion-reduce:animate-none"
			/>
		</div>

		<div :class="AGENT_SHORTS_GRID_CLASS" aria-hidden="true">
			<Skeleton
				v-for="skeletonIndex in AGENT_SHORTS_SKELETON_COUNT"
				:key="`agent-shorts-skeleton-${skeletonIndex}`"
				is-active
				variant="white"
				:class="AGENT_SHORTS_CARD_CLASS"
				data-testid="agent-shorts-card-skeleton"
			/>
		</div>

		<Skeleton
			is-active
			variant="white"
			class="mt-6 h-12 w-full rounded-none motion-reduce:animate-none md:w-[148px]"
			data-testid="agent-shorts-view-more-skeleton"
			aria-hidden="true"
		/>
	</section>
</template>
